import { render, staticRenderFns } from "./IpuForm.vue?vue&type=template&id=18a487ea&scoped=true"
import script from "./IpuForm.vue?vue&type=script&lang=js"
export * from "./IpuForm.vue?vue&type=script&lang=js"
import style0 from "./IpuForm.vue?vue&type=style&index=0&id=18a487ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a487ea",
  null
  
)

export default component.exports